<template>
    <div class="fixed-center text-center">

        <q-avatar color="negative" text-color="white" icon="mdi-hammer-wrench" :size="screenSize.xs ? '7em' : '10em'" class="q-ma-xl" />

        <p :class="screenSize.xs ? 'text-h5' : 'text-h4'">
            Sorry, we are currently down for maintenance.
        </p>
        <p :class="screenSize.xs ? 'text-h6' : 'text-h5'" class="text-weight-light">
            We will be back shortly...
        </p>
    </div>
</template>
<script>
    import axios from 'axios'
    import api from '@/api/api-endpoints'

    export default {
        name: 'maintenance',
        data() {
            return {

            }
        },
        methods: {
            checkStatus() {
                axios.get(api.status, { headers: { 'Authorization': 'Bearer ' } })
                    .then(response => {
                        //check if status is completed, if it is stop polling
                        if (response && response.data) {
                            this.$router.push('/').catch(err => { })
                        }
                    })
                    .catch(err => {
                        setTimeout(() => { this.checkStatus() }, 10000)
                    })
            },
        },
        computed: {
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            this.checkStatus()
        }
    }
</script>